import { getGameResults } from "./GetGameResults";

/**
 * Per-match scheduled / played flags using the same rules as FasesContainer.
 */
export function getMatchProgressContribution(
  match,
  poule,
  bracketsByKey,
  tournament,
) {
  let hideMatch = false;
  if (poule["status" + match.team1]) {
    hideMatch = true;
  }
  if (poule["status" + match.team2]) {
    hideMatch = true;
  }
  if (poule.bracket && poule.losersFinal === true) {
    if (!(bracketsByKey[poule.bracket] || {}).showLosersFinal) {
      hideMatch = true;
    }
  }
  const countScheduled =
    (match.field !== null || tournament.online) && !hideMatch;

  let scoreType =
    poule.scoreType ||
    (poule.bracket
      ? (bracketsByKey[poule.bracket] || {})["scoreType"]
      : false) ||
    ((tournament.scoringTypesPerDivisionPerPhase || {})[poule.division] ||
      {})[poule.fase] ||
    "default";
  let scoring =
    scoreType === "default"
      ? tournament
      : (tournament.scoringTypes || {})[scoreType] || tournament;

  let useSets = (scoring.useSets || "0") === "1";
  let gameResults = getGameResults(scoring, match.sets || {});

  const countPlayed =
    (useSets
      ? gameResults.finished
      : match.score1 !== null && match.score2 !== null) && !hideMatch;

  return { countScheduled, countPlayed };
}

/**
 * Tournament-wide totals (not split by division / phase).
 */
export function sumMatchProgressForTournament(
  matches,
  poulesByKey,
  bracketsByKey,
  tournament,
) {
  let played = 0;
  let scheduled = 0;
  if (!matches || !poulesByKey || !tournament) {
    return { played, scheduled };
  }
  for (let m in matches) {
    const match = matches[m];
    const poule = poulesByKey[match.poule];
    if (!poule) {
      continue;
    }
    const { countScheduled, countPlayed } = getMatchProgressContribution(
      match,
      poule,
      bracketsByKey || {},
      tournament,
    );
    if (countScheduled) {
      scheduled++;
    }
    if (countPlayed) {
      played++;
    }
  }
  return { played, scheduled };
}
